<div class="container-fluid">
  <div class="row">
    <div class="modal-header border-0 offset-md-10 col-md-2">
      <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</div>
<div class="container-fluid mb-5">
  <div class="row">
    <div class="col-12 mt-2">
      <app-total-table
        [showRegistersPerPage]="true"
        (onChange)="updatePageSize($event)"
        [totalRegistros]="this.totalRegistros"></app-total-table>
      <table aria-label="Detalhes último processamento"
        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
        <thead>
        <tr>
          <th scope="col" style="width: 20%">Carteira</th>
          <th scope="col" style="width: 5%">Data</th>
          <th scope="col" style="width: 12%">Data hora execução</th>
          <th scope="col" style="width: 5%">Execução</th>
          <th scope="col" style="width: 20%">Regra</th>
          <th scope="col" style="width: 10%">Status regra</th>
          <th scope="col" style="width: 28%">Mensagem</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let r of resultadoRegras">
          <tr class="element-row">
            <td>{{ r.carteira.nome }}</td>
            <td>{{ r.dataEnquadramento | date: 'dd/MM/yyyy' }}</td>
            <td>{{ r.timeStamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>{{ getTipoExecucao(r.tipoExecucao) }}</td>
            <td class="regra" (click)="rowClicked(r)">
              <i *ngIf="r == expandedElement && r.subregras && r.subregras.length > 0"
                 class="fas fa-minus-square subregra-button" aria-hidden="true"></i>
              <i *ngIf="r != expandedElement && r.subregras && r.subregras.length > 0"
                 class="fas fa-plus-square subregra-button" aria-hidden="true"></i>
              {{ r.regra.nome }}
            </td>
            <td>{{ r.status }}</td>
            <td>{{ r.mensagem }}</td>
          </tr>
          <ng-container *ngIf="r == expandedElement">
            <tr *ngFor="let s of r.subregras" class="opacity-4">
              <td>{{ s.carteira.nome }}</td>
              <td>{{ s.dataEnquadramento | date: 'dd/MM/yyyy'  }}</td>
              <td>{{ s.timeStamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ getTipoExecucao(r.tipoExecucao) }}</td>
              <td class="subregra">{{ s.regra.nome }}</td>
              <td>{{ s.status }}</td>
              <td>{{ s.mensagem }}</td>
            </tr>
          </ng-container>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <maps-pagination
      [pageNumber]="page$"
      [items]="paginationTotalPage"
      *ngIf="paginationTotalPage && paginationTotalPage > 0"
      (pageSend)="receiverPage($event)"
    ></maps-pagination>
  </div>
</div>


